// extracted by mini-css-extract-plugin
module.exports = {"responsibilityFigure":"EquipmentResponsibilityDetails_responsibilityFigure__n2s2z","responsibilityImage":"EquipmentResponsibilityDetails_responsibilityImage__DsAHi"};